import * as React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="0.686279" width="16" height="16" transform="rotate(45 12 0.686279)" fill="white" />
  </svg>
)
